export enum SharingType {
  profile = 'profile',
  profilePhoto = 'profile_photo',
}

export const shareContentPhotoViewerTooltipId =
  'shareContentPhotoViewerTooltipId'
export const shareContentModalTooltipId = 'shareContentModalTooltipId'
/**
 * @deprecated
 */
export const sharingMethodClipBoard = 'url'
